import React from "react"

// Check if window is defined (so if in the browser or in node.js).
const isBrowser = typeof window !== "undefined"

const Overlay = ({isVisible}) => {
    if (isBrowser) {
        isVisible ? document.querySelector("body").style.overflow="hidden": document.querySelector("body").style.overflow="visible";
    }
    return <div className={`overlay ${isVisible ? "is-visible":""}`}></div>}
export default Overlay;